import React, {Component} from "react";
import {mesAutobind} from "@posco/posco-shared";
import {inject, observer} from "mobx-react";
import O10g014112View from "../view/O10g014112View";

/*다국어 적용을 위한 whitTranslation import*/
import {withTranslation} from "react-i18next";

@inject("o10g014112Stores")
@mesAutobind
@observer
class O10g014112Container extends Component {


  /*props로부터 다국어 표현을 위한 t함수 획득*/
  get translate() {
    const {t} = this.props;
    //console.log(t)
    return ({
      O10_LH_00018: t("O10_LH_00018", {ns: "common"}),//전체
      O10_LH_00019: t("O10_LH_00019", {ns: "common"}),//건
      O10_MW_00009: t("O10_MW_00009", {ns: "common", 0: t("O10G014110_LH_00002", {ns: "service"})})//"{{0}}을(를) 필수로 선택하시기 바랍니다."
    });
  }

  componentDidMount() {
  }

  //유저정보변경
  async onUserInfoChange(param) {
    const result = await this.props.o10g014112Stores.change(param);
    return result;
  }

  //로컬피씨 이미지 업로드
  async onProfileImgUpload(formData) {
    const result = await this.props.o10g014112Stores.profile(formData);
    return result;
  }

  // 예시 이미지중 선택
  async onSelectProfileImg(param) {
    const result = await this.props.o10g014112Stores.profile2(param);
    return result;
  }

  render() {
    return (
      <O10g014112View
        open={this.props.open}
        openToggle={this.props.openToggle}
        userInfo={this.props.userInfo}
        onUserInfoFind={this.props.onUserInfoFind}

        translate={this.translate}
        onUserInfoChange={this.onUserInfoChange}
        onProfileImgUpload={this.onProfileImgUpload}
        onSelectProfileImg={this.onSelectProfileImg}
      />

    );
  }
}

export default withTranslation()(O10g014112Container);
